import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef } from '@angular/material/snack-bar';
import { TypeAlertEnum } from '@shared/enums/type.alert.enum';
import { DataNotificacion } from './interfaces/data.notificacion';

/**
 * Componente personalizado de las notificaciones, se invoca desde el servicio
 *
 * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
 */
@Component({
  selector: 'notificacion',
  standalone: true,
  imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions],
  templateUrl: './notificacion.component.html'
})
export class NotificacionComponent {

  // Inyecciones de dependencias
  private _snackBarRef = inject(MatSnackBarRef<NotificacionComponent>);

  /** Define los datos de entrada para la notificación */
  private _data: DataNotificacion = inject(MAT_SNACK_BAR_DATA);

  /** Define el color del tipo de alerta (listo antes del primer paint). */
  private _alertColor: string = 'normal';

  /** Define el título de la notificación (listo antes del primer paint). */
  private _title: string = '';

  constructor() {
    this.aplicarTipoAlerta();
  }

  /**
   * Resuelve color y titulo segun el tipo de alerta recibido.
   * Se ejecuta en el constructor para no pintar un frame vacio.
   */
  private aplicarTipoAlerta(): void {
    switch (this._data?.typeAlertEnum) {
      case TypeAlertEnum.SUCCESS:
        this._alertColor = 'success';
        this._title = 'Exitoso';
        break;
      case TypeAlertEnum.INFO:
        this._alertColor = 'azul-secundario';
        this._title = 'Informativo';
        break;
      case TypeAlertEnum.WARNING:
        this._alertColor = 'warning';
        this._title = 'Advertencia';
        break;
      case TypeAlertEnum.ERROR:
        this._alertColor = 'error';
        this._title = 'Error';
        break;
      default:
        this._alertColor = 'normal';
        this._title = '';
        break;
    }
  }

  /**
   * Propiedad que devuelve la referencia de la notificación
   *
   * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
   */
  public get snackBarRef(): MatSnackBarRef<NotificacionComponent> {
    return this._snackBarRef;
  }

  /**
   * Propiedad que devuelve la data de la notificación
   *
   * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
   */
  public get data(): DataNotificacion {
    return this._data;
  }

  /**
   * Propiedad que devuelve el color del tipo de alerta
   *
   * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
   */
  public get alertColor(): string {
    return this._alertColor
  }

  /**
   * Propiedad que devuelve el título de la notificación
   *
   * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
   */
  public get title(): string {
    return this._title;
  }

}
